import React, { useEffect, useRef, useState } from "react";
import { Box, Checkbox, Dialog, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CancelOutlined, KeyboardArrowLeft, KeyboardArrowRight, ReportProblemOutlined } from "@mui/icons-material";
import dayjs, { Dayjs } from "dayjs";
import aldi from '../../../assets/Project_Images/Aldi_logo.png'
import blooms from '../../../assets/Project_Images/Blooms_logo.png'
import mm from '../../../assets/Project_Images/MM_logo.png'
import {
  ApiGetAllocationCriteriaDetails,
  appliedAllocations,
  fetchAllocations,
} from "../../../apiService/Core/Apicall.tsx";
import Loading from "../../Loader/Loading.tsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import store, { RootState } from "../../../Redux/Store.tsx";
import { hideLoading, showLoading } from "../../../Redux/loadingSlice.tsx";
import { setSelectedMonth } from "../../../Redux/MonthSlice.tsx";
import { toast } from "react-toastify";

function Calendar() {
  // Function name remains 'Calendar'
  const defaultMonth = useSelector((state: RootState) => state.month.selectedMonth)
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs(defaultMonth));
  const [AllocationList, setAllocationList] = useState<any>();
  const [events, setEvents] = useState<{ title: string; start: string }[]>([]);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const loading = useSelector((state: RootState) => state.loader.isLoading);
  const [allocationCriteria, setAllocationCriteria] = useState<any>([]);
  const [isneeddatechange, setisneeddatechange] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const handlePrevMonth = () => {
    const newMonth = dayjs(defaultMonth).subtract(1, "month").toISOString();
    dispatch(setSelectedMonth(newMonth));
  };

  // Handle Next Month
  const handleNextMonth = () => {
    const newMonth = dayjs(defaultMonth).add(1, "month").toISOString();
    dispatch(setSelectedMonth(newMonth));
  };

  useEffect(() => {
    const fetchappliedallocations = async () => {
      // store.dispatch(showLoading())
      const jobMonth = selectedDate.month() + 1; // +1 because getMonth() returns 0-11
      const jobYear = selectedDate.year();

      //let data = `?offset=0&limit=100&allocationStatus=approved&jobMonth=${jobMonth}&jobYear=${jobYear}&userId=${userData.userId}`;
      const params = {
        userId: userData.userId,
        jobMonth: selectedDate.month() + 1,
        jobYear: selectedDate.year(),
        offset: 0,
        limit: 1000,
        // status: "approved",
        isUseForShopperCalendar:true
      };
      const res = await appliedAllocations(params)
      // const res = await fetchAllocations(params);
      if (res.data) {
      }
      setAllocationList(res.data || []);
      // store.dispatch(hideLoading())
    };
    fetchappliedallocations();
  }, [selectedDate]);

  useEffect(() => {
    if (AllocationList?.length > 0) {
      const formattedEvents = AllocationList.map((item, index) => ({
        title: `${item?.allocationId?.venueId?.venueName}`,
        start: item?.selectedVisitDate?.split("T")[0],
        extendedProps: {
          item: item,
          index: index,
          clientgroup: item?.allocationId.allocationClientGroup,
          venueName: item?.allocationId?.venueId?.venueName ?? item?.allocationId?.clientEntityId?.entityName,
          allocationId: item.appliedAllocationId,
          venueDescription: item?.allocationId?.venueId?.venueDescription,
          status: item?.allocationId?.clientEntityId?.entityTypeId?.entityTypeName,
          time: item?.selectedVisitDate,
          visittime: item.selectedVisitTime.visitTimeInformation,
          locationType: item?.allocationId?.venueId?.locationType,
          clientEntityName: item?.allocationId?.clientEntityId?.entityName,
          checkInDateTime: item?.allocationId.checkInDateTime,
          checkOutDateTime: item?.allocationId.checkOutDateTime,
          reportStatus: item?.allocationId.reportStatus,
          allocationstatus: item?.status?.statusCode,
          isNeedToChangeVisitDate: item?.isNeedToChangeVisitDate,
          regionName: item?.allocationId?.venueId?.regionId?.regionName,
        },
      }));


      setEvents(formattedEvents);
    }
  }, [AllocationList, selectedDate]);
  const navigate = useNavigate();
  const handleClick = (allocationId: Number) => {
    navigate("/dashboard/MyTasks", {
      state: {
        taskId: allocationId,
        selecteddatefromcalender: selectedDate.format("YYYY-MM-DD"),
      },
    });
    localStorage.setItem("ActiveTask", "MyTask");
  };

  // const renderEventContent = (eventInfo: any) => {
  //   return (
  //     <Box
  //       onClick={() => {
  //         handleClick(eventInfo.event.extendedProps.allocationId);
  //       }}
  //       border="2px solid #FFCB67"
  //       bgcolor="#FFCB671A"
  //       className="mx-2 h-100 mb-2"
  //       padding="10px"
  //       borderRadius="10px"
  //     >
  //       <Typography
  //         className="fw-bold text-dark"
  //         whiteSpace="wrap"
  //         variant="subtitle1"
  //       >
  //         {eventInfo.event.title}
  //       </Typography>
  //       <Typography
  //         className="text-dark mb-1"
  //         whiteSpace="wrap"
  //         variant="subtitle1"
  //       >
  //         {eventInfo.event.extendedProps.time}
  //       </Typography>
  //       {/* <Typography className="text-dark" variant="subtitle1">{eventInfo.event.extendedProps.venueDescription}</Typography> */}
  //       <Box className="d-flex">
  //         <Typography
  //           variant="caption"
  //           className="px-3 py-1 text-grey"
  //           borderRadius="5px"
  //           bgcolor={"#ADB79233"}
  //         >
  //           {eventInfo.event.extendedProps.status}
  //         </Typography>
  //       </Box>
  //     </Box>
  //   );
  // };

  const fetchAllocationCriteria = async (item: any, userId) => {
    try {
      const data = `?allocationId=${item.allocationId.allocationId}&clientEntityId=${item.allocationId?.venueId?.clientEntityId?.clientEntityId}&userId=${userId}`;
      const response = await ApiGetAllocationCriteriaDetails(data);
      setAllocationCriteria(response.data);
      setisneeddatechange(true)
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      console.log(message)
    }

  };
  const renderEventContent = (eventInfo: any) => {
    const allocation = eventInfo.event.extendedProps;

    // Default colors
    let cardColor = "#000000";
    let fontColor = "#ffffff";

    if (allocation.reportStatus === "app" || allocation.reportStatus === "rel" || allocation.reportStatus === "atc") {
      cardColor = "grey";
      fontColor = 'white'
    }
    else if (allocation.reportStatus === "con") {
      cardColor = "#7C9FB2";
    }
    else {

      if (allocation.checkOutDateTime?.length > 0 && allocation.checkOutDateTime !== null) {
        cardColor = "green";
        fontColor = "#ffffff !important";
      }
      else if (allocation.checkInDateTime?.length > 0 && allocation.checkInDateTime !== null) {
        cardColor = "yellow";
        fontColor = '#000000'
      }
      else {
        if (allocation.allocationstatus === "shopper_applied") {
          cardColor = "orange";
        }
        else if (allocation.allocationstatus === "approved" && allocation.locationType === "city") {
          cardColor = "rgb(121,104,232)";
        }
        else if (allocation.allocationstatus === "approved" && allocation.locationType === "region") {
          cardColor = "rgb(245,194,203)";
          fontColor = '#000000'
        }
        else {
          cardColor = "#000000";
        }
      }

    }



    return (
      <Box

        // border="2px solid #FFCB67"
        bgcolor={cardColor}
        color={fontColor}
        className="mx-2 h-100 mb-2"
        padding="10px"
        // width={'150px'}
        maxWidth={'220px'}
        borderRadius="10px"
      >
        {/* <Checkbox  /> */}
        <Box onClick={() => handleClick(allocation.allocationId)} sx={{ cursor: 'pointer' }} >
          <Box className='pb-2 mb-2 d-flex w-100' borderBottom='1px solid black'>
            <Box component='img' src={allocation.clientgroup === 'ALDI' ? aldi : allocation.clientgroup == 'BLOOMS' ? blooms : mm} bgcolor='white' height='24px' width='24px' borderRadius='50px' />
            <Typography className="mx-2" sx={{ whiteSpace: 'wrap' }}>{allocation.venueName}</Typography> <Typography></Typography>
          </Box>
          <Typography
            className="mb-1"
            whiteSpace="wrap"
            variant="subtitle2"
          >
            {allocation.visittime}
          </Typography>
          <Typography
            className="mb-1"
            whiteSpace="wrap"
            variant="subtitle2"
          >
            {allocation.clientEntityName} {(allocation?.regionName && allocation?.clientgroup == "ALDI") ? `(${allocation?.regionName})` : ""}
          </Typography>
          {/* <Typography
            className="mb-1"
            whiteSpace="wrap"
            variant="subtitle2"
          >
            ({eventInfo.event.title})
          </Typography> */}
        </Box>

        {/* <Box className="d-flex">
          <Typography
            variant="caption"
            className="px-3 py-1 text-grey"
            borderRadius="5px"
            bgcolor="#ADB79233"
          >
            {allocation.status}
          </Typography>
        </Box> */}
        <Box className='d-flex justify-content-end'>
          {allocation?.isNeedToChangeVisitDate === true && (

            <IconButton onClick={() => { fetchAllocationCriteria(allocation.item, allocation.item?.userId?.userId); setSelectedId(allocation.index) }} className="animated-alert ms-auto p-0">
              <ReportProblemOutlined sx={{ fill: 'red !important' }} />
            </IconButton>

          )}
          <Typography>{allocation?.isNeedToChangeVisitDate}</Typography>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    setSelectedDate(dayjs(defaultMonth))
  }, [defaultMonth])

   const isWeekend = (date: string | Date | undefined | null) => {
      if (!date) return false;
  
      const day = dayjs(date).day(); // 0 = Sunday, 6 = Saturday
      return day === 0 || day === 6;
    };

  return (
    <Box className="p-3" height="calc(100vh - 65px)">
      {AllocationList?.data?.length > 0 &&
        AllocationList.data.map((item, index) => (
          <Typography key={index}>{item.appliedAllocationId}</Typography>
        ))}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // push items to edges
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <span style={{ fontWeight: 500 }}>Code :</span>
          {[
            // { label: "Approved - Metro", color: "#BF613B" },
            { label: "Approved - Metro", color: "rgb(121,104,232)" },
            { label: "Approved - Regional", color: "rgb(245,194,203)" },
            // { label: "Applied", color: "orange" },
            { label: "CheckedIn", color: "yellow" },
            { label: "Checkout", color: "green" },
            { label: "Report Submitted", color: "#7C9FB2" },
            { label: "Report Approved", color: "grey" },
          ].map((item, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: item.color,
                color: ["yellow", "pink", "rgb(245,194,203)", "hotpink", "skyblue"].includes(
                  item.color
                )
                  ? "#000"
                  : "#fff",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          display="flex"
          alignItems="center"
          width="fit-content"
          maxWidth="330px"
          className="d-flex ms-auto mb-2 align-items-center month-calendar justify-content-start"
        >
          {/* Previous Month Button */}
          <IconButton onClick={handlePrevMonth} className="d-none d-md-block">
            <KeyboardArrowLeft />
          </IconButton>

          <DatePicker
            views={["year", "month"]}
            value={selectedDate}
            onChange={(date) => date && dispatch(setSelectedMonth(date.toISOString()))}
            renderInput={(params) => (
              <TextField {...params} variant="standard" />
            )}
          />

          <IconButton onClick={handleNextMonth} className="d-none d-md-block">
            <KeyboardArrowRight />
          </IconButton>
        </Box>
      </LocalizationProvider>
      <FullCalendar
        height="calc(100% - 50px)"
        plugins={[dayGridPlugin]}
        key={selectedDate.format("YYYY-MM-DD")}
        initialView="dayGridMonth"
        initialDate={selectedDate.format("YYYY-MM-DD")}
        showNonCurrentDates={false}
        events={events}
        eventContent={renderEventContent}
        eventBackgroundColor="transparent"
        eventBorderColor="transparent"
      />

      <Dialog sx={{ width: { xs: "300px", md: "500px" } }} className="mx-auto" open={isneeddatechange} onClose={() => { setisneeddatechange(false) }}>
        <Box className='p-2 w-100'>
          <Box className='d-flex w-100 justify-content-end'>

            <IconButton onClick={() => { setisneeddatechange(false) }}><CancelOutlined /></IconButton>
          </Box>
          <Box className='p-3'>
            <ul>
              {(allocationCriteria?.shouldBeDifferentDayFromPreviousMonth === true && dayjs(allocationCriteria?.lastJobVisitedDate).format('dddd') === dayjs(AllocationList[selectedId]?.selectedVisitDate).format('dddd')) && (
                <li>
                  <Typography>Two consecutive months cannot be assigned to {dayjs(AllocationList[selectedId]?.selectedVisitDate).format('dddd')}</Typography>
                  <Typography>
                    If there is no suitable date, contact{" "}
                    <a href="mailto:bryan@mysterymanagement.com.au">
                      bryan@mysterymanagement.com.au
                    </a>{" "}
                    for a solution.
                  </Typography>
                </li>
              )
              }
              {allocationCriteria?.isNeedToHideWeekend && isWeekend(AllocationList[selectedId]?.selectedVisitDate) && (
                <li>
                  <Typography>⁠⁠A maximum of {allocationCriteria?.maxConsecutiveWeekendDays} consecutive months can be assigned to weekends. Please choose a weekday instead.</Typography>
                </li>
              )}
              {allocationCriteria?.isNeedToHideNonWeekend && !isWeekend(AllocationList[selectedId]?.selectedVisitDate) && (
                <li>
                  <Typography>⁠⁠A maximum of {allocationCriteria?.maxConsecutiveNonWeekendDays} consecutive months can be assigned to weekdays. Please choose a weekend instead.</Typography>
                </li>
              )}
            </ul>

            <Typography
              component="div"
              dangerouslySetInnerHTML={{ __html: `${allocationCriteria?.venueClosePlus3Days ? `<p>DO NOT audit or mysteryshop this store between ${dayjs(allocationCriteria?.venueClosePlus3Days).format('DD/MM/YYYY') ?? ""} to ${dayjs(allocationCriteria?.venueOpenMinus7Days).format("DD/MM/YYYY") ?? ""} inclusive</p>` : ""}${allocationCriteria?.venueMessage !== null ? `<p>${allocationCriteria?.venueMessage}` : ""}` }}
            />
          </Box>
        </Box>
      </Dialog>
      {loading && <Loading />}
    </Box>
  );
}

export default Calendar;
